import { render, staticRenderFns } from "./UpdateVariance.vue?vue&type=template&id=35b35476"
import script from "./UpdateVariance.vue?vue&type=script&lang=js"
export * from "./UpdateVariance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports